import React from 'react';
import { observer } from 'mobx-react';
import { Flex, Spinner, Tag, Text } from 'core/components';
import { RemoveButton } from 'core/form/components';
import { MCP_AUTH_TYPE } from '@kentik/ui-shared/kaizen/constants';
import McpOAuthControls from 'app/components/McpOAuthControls';

const OAuthAccessCell = observer(({ $mcpServers, model }) => {
  if (model.get('auth_type') !== MCP_AUTH_TYPE.OAUTH || !model.get('enabled')) {
    return (
      <Text small muted>
        --
      </Text>
    );
  }

  const status = $mcpServers.oauthStatusMap.get(model.get('id'));
  const id = model.get('id');

  if (!status || status.loading) {
    return <Spinner size={12} />;
  }

  if (status.connected && !status.connecting) {
    return (
      <Flex alignItems="center" gap={1}>
        <Tag minimal intent="success">
          Connected
        </Tag>
        <RemoveButton
          model={model}
          showIcon
          hideText
          small
          entityName="OAuth connection"
          onRemove={() => $mcpServers.disconnectOAuth(id)}
        />
      </Flex>
    );
  }

  return <McpOAuthControls serverId={id} serverName={model.get('name')} />;
});

export default OAuthAccessCell;
